
  export default {
    name: 'ThemeStoresMobileAndroidFooter',
    computed: {
      footers() {
        return [
          { text: 'Play Pass' },
          { text: 'Play Points' },
          { text: this.tl('giftCards') },
          { text: this.tl('redeem') },
          { text: this.tl('refundPolicy') },
          { text: this.tl('kidsAndFamily') },
          { text: this.tl('parentGuide') },
          { text: this.tl('familySharing') }
        ]
      },
      policy() {
        return [
          { text: this.tl('ternsOfService') },
          { text: this.tl('privacy') },
          { text: this.tl('aboutGooglePlay') },
          { text: this.tl('developers') },
          { text: this.tl('googleStore') }
        ]
      }
    }
  }
